module.exports = __webpack_public_path__ + "img/img_header_partens.3cfde029.jpg";